module.exports = __webpack_public_path__ + "img/bx-star.6e20e2ac.svg";